import React from 'react';
import { Hourglass } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Semi-transparent overlay wrapper for features that are coming soon /
 * under development. Wrap any block to dim it and block interaction.
 */
export default function FeatureOverlay({
  visible = true,
  title = 'Coming Soon',
  subtitle = 'This feature is under development.',
  blur = false,
  className,
  children,
}) {
  if (!visible) return children;

  return (
    <div className={cn('relative', className)}>
      <div
        className={cn('pointer-events-none select-none opacity-60', blur && 'blur-[1.5px]')}
        aria-hidden="true">
        {children}
      </div>

      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center rounded-xl bg-black/55 text-center p-4">
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/20 border border-primary/40 mb-2">
          <Hourglass className="w-3.5 h-3.5 text-white" />
          <span className="text-xs font-semibold uppercase tracking-wide text-white">{title}</span>
        </div>
        {subtitle && <p className="text-xs text-white/80 max-w-xs leading-relaxed">{subtitle}</p>}
      </div>
    </div>
  );
}
